import React from 'react'

import { useSettings } from '../../hooks/useSettings'

const CommitSVG = ({
  isDisabled = false,
  styles = '',
  isBlueColor = false,
}) => {
  const { isDarkMode } = useSettings()

  // const color = isDarkMode ? '#ffffff' : '#0E2E4C'
  const color = isBlueColor ? '#0E2E4C' : '#ffffff'

  return (
    <svg
      className={styles}
      width="24"
      height="24"
      viewBox="0 0 34 34"
      fill="none"
      opacity={isDisabled ? '0.5' : '1'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        clipPath="url(#a)"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
      >
        <path
          d="m12.042 17.708 2.833 2.834 7.083-7.084"
          strokeLinejoin="round"
        />
        <path d="M9.917 4.729A14.1 14.1 0 0 1 17 2.833c7.824 0 14.167 6.343 14.167 14.167S24.824 31.167 17 31.167 2.833 24.824 2.833 17c0-2.58.69-5 1.896-7.083" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill={color} d="M0 0h34v34H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CommitSVG
